export default "__VITE_ASSET__BByUvyBj__"